<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white text-gray-800">
    <div class="w-full max-w-4xl p-6 mx-auto">
      <AppHeader :currentDateTime="currentDateTime" />

      <!-- Main Content -->
      <main class="flex flex-col md:flex-row gap-12 animate-fade-in-up" style="animation-delay: 0.3s">
        <AppSidebar />
        <section class="md:w-3/4 md:pl-8 font-inter text-lg leading-relaxed">
          <p class="mb-6">
            I'm a professional <span class="text-emerald-600 font-semibold">Python developer</span> and <span class="text-emerald-600 font-semibold">AI Engineer</span>  architecting robust
            <span class="text-emerald-600 font-semibold">AI solutions</span> and advanced
            <span class="text-emerald-600 font-semibold">AI orchestration</span> platforms.
          </p>
          <p class="mb-6">
            I engineer high-performance systems for enterprise optimization, specializing in
            <span class="text-emerald-600 font-semibold">Machine Learning</span>,
            <span class="text-emerald-600 font-semibold">Harness</span>,
            <span class="text-emerald-600 font-semibold">Agentic Architectures</span>,
            <span class="text-emerald-600 font-semibold">RAG Pipelines</span>, and
            <span class="text-emerald-600 font-semibold">SOTA LLMs</span>.
          </p>
          <p class="mb-6">
            Currently building scalable AI infrastructure that transforms business operations. I bridge the gap between state-of-the-art models and production-grade engineering, delivering resilient, high-impact workflows through rigorous AI orchestration.
          </p>
        </section>
      </main>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import AppSidebar from './AppSidebar.vue'

import '@/assets/styles/main.css'; // Импортируйте ваш CSS файл

export default {
  name: "PersonalSite",
  components: {
    AppHeader,
    AppFooter,
    AppSidebar
  },
  data() {
    return {
      currentDateTime: '',
      updateInterval: null
    }
  },
  mounted() {
    this.updateDateTime()
    this.updateInterval = setInterval(this.updateDateTime, 1000)
  },
  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
    }
  },
  methods: {
    updateDateTime() {
      const now = new Date()
      this.currentDateTime = now.toISOString().replace('T', ' ').substr(0, 19)
    }
  }
};
</script>
